import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { CheckoutFormsStoreModule } from 'src/app/core/checkout/checkout-forms-store.module';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { CheckoutOrderTypeComponent } from './checkout-order-type.component';

@NgModule({
  imports: [CommonModule, I18nModule, DynamicFormsModule, CheckoutFormsStoreModule, CheckoutOrderTypeComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutOrderType: {
          component: CheckoutOrderTypeComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [CheckoutOrderTypeComponent],
})
export class CheckoutOrderTypeModule {}
